import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IFilterDropdown } from "../AppState/overagesFilterFormActions";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @returns - Master dropdown records of type IFilterDropdown[]
 */

export const getFilterDropdowns = async (params: { dataType: string }): Promise<IFilterDropdown[]> => {
  try {
    const response = await axios.get(getUrl(ApiType.MASTER_RECORDS), { params });
    return response?.data?.data ?? [];
  } catch (error) {
    return throwApiError(error, ErrorMessages.terminalAPIError, { badRequestOrder: "errorsFirst" });
  }
};
